<div data-testid="simple-message">
    <div class="app-alert__title bg-style color-light font-18 font-bold">
        {{ item.module.name }}
    </div>

    <div class="app-alert__close-alarm color-light font-14 cursor-pointer" (click)="closePopup(key)">
        <img class="app-alert__close-alarm-img" src="/assets/img/icons/clear-button.svg" alt="Zamknij">
    </div>

    <div class="app-alert__message app-alert__message--alert font-15 cursor-default">
        {{ formatAlarmText(item.data) }}
    </div>

    <div class="app-alert__buttons-box app-alert__buttons-box--alert">
        <input type="button"
               [value]="subtitles.setSubtitle(475)"
               class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="popup.clearPopup(key)" />
        <div class="app-alert__button bg-default color-light font-bold font-14 cursor-pointer"
             *ngIf="parameters.selectedModuleIndex !== item.module.id && item.module.id >= 0"
             (click)="switchModule(item.module, key)">
            <img class="app-alert__enter-module-img" src="/assets/img/icons/enter.svg" [alt]="subtitles.setSubtitle(4854)">
            <p>{{ subtitles.setSubtitle(4854) }}</p>
        </div>
    </div>
</div>
